export const LEAD_GROUPS_TAGS = {
  LEAD_GROUPS: "LeadGroups",
} as const;
